/**
 * @description GeoGebra defined names for tool icons in the toolbar.
 * the key corresponds to the value returned by ggbApplet.getMod();
 * For a complete list look here:
 * [https://wiki.geogebra.org/en/Reference:Toolbar]{@link}
 */

import svg0 from './mode-0.svg';
import svg1 from './mode-1.svg';
import svg2 from './mode-2.svg';
import svg3 from './mode-3.svg';
import svg4 from './mode-4.svg';
import svg5 from './mode-5.svg';
import svg6 from './mode-6.svg';
import svg7 from './mode-7.svg';
import svg8 from './mode-8.svg';
import svg9 from './mode-9.svg';
import svg10 from './mode-10.svg';
import svg11 from './mode-11.svg';
import svg12 from './mode-12.svg';
import svg13 from './mode-13.svg';
import svg14 from './mode-14.svg';
import svg15 from './mode-15.svg';
import svg16 from './mode-16.svg';
import svg17 from './mode-17.svg';
import svg18 from './mode-18.svg';
import svg19 from './mode-19.svg';
import svg20 from './mode-20.svg';
import svg21 from './mode-21.svg';
import svg22 from './mode-22.svg';
import svg23 from './mode-23.svg';
import svg24 from './mode-24.svg';
import svg25 from './mode-25.svg';
import svg26 from './mode-26.svg';
import svg27 from './mode-27.svg';
import svg28 from './mode-28.svg';
import svg29 from './mode-29.svg';
import svg30 from './mode-30.svg';
import svg31 from './mode-31.svg';
import svg32 from './mode-32.svg';
import svg33 from './mode-33.svg';
import svg34 from './mode-34.svg';
import svg35 from './mode-35.svg';
import svg36 from './mode-36.svg';
import svg37 from './mode-37.svg';
import svg38 from './mode-38.svg';
import svg39 from './mode-39.svg';
import svg40 from './mode-40.svg';
import svg41 from './mode-41.svg';
import svg42 from './mode-42.svg';
// import svg43 from "./mode-43.svg";
import svg44 from './mode-44.svg';
import svg45 from './mode-45.svg';
import svg46 from './mode-46.svg';
import svg47 from './mode-47.svg';
import svg48 from './mode-48.svg';
import svg49 from './mode-49.svg';
import svg50 from './mode-50.svg';
import svg51 from './mode-51.svg';
import svg52 from './mode-52.svg';
import svg53 from './mode-53.svg';
import svg54 from './mode-54.svg';
import svg55 from './mode-55.svg';
import svg56 from './mode-56.svg';
import svg57 from './mode-57.svg';
import svg58 from './mode-58.svg';
import svg59 from './mode-59.svg';
import svg60 from './mode-60.svg';
import svg61 from './mode-61.svg';
import svg62 from './mode-62.svg';
import svg64 from './mode-64.svg';
import svg65 from './mode-65.svg';
import svg66 from './mode-66.svg';
import svg67 from './mode-67.svg';
import svg68 from './mode-68.svg';
// import svg69 from "./mode-69.svg";
import svg70 from './mode-70.svg';
import svg71 from './mode-71.svg';
import svg72 from './mode-72.svg';
import svg501 from './mode-501.svg';
import svg2002 from './mode-2002.svg';
import svg2003 from './mode-2003.svg';
import svg2004 from './mode-2004.svg';
import svg2005 from './mode-2005.svg';
import svg2020 from './mode-2020.svg';
import svg2021 from './mode-2021.svg';
import svg2022 from './mode-2022.svg';
// import svg2030 from "./mode-2030.svg";
// import svg2031 from "./mode-2031.svg";
// import svg2032 from "./mode-2032.svg";
import svg2040 from './mode-2040.svg';
import svg2041 from './mode-2041.svg';
import svg2042 from './mode-2042.svg';
import svg2043 from './mode-2043.svg';
import svg2044 from './mode-2044.svg';
import svg73 from './mode-73.svg';
import svg502 from './mode-502.svg';
import svg510 from './mode-510.svg';
import svg511 from './mode-511.svg';
import svg512 from './mode-512.svg';
import svg513 from './mode-513.svg';
import svg514 from './mode-514.svg';
import svg520 from './mode-520.svg';
import svg521 from './mode-521.svg';
import svg522 from './mode-522.svg';
import svg523 from './mode-523.svg';
import svg531 from './mode-531.svg';
import svg532 from './mode-532.svg';
import svg533 from './mode-533.svg';
import svg534 from './mode-534.svg';
import svg535 from './mode-535.svg';
import svg536 from './mode-536.svg';
import svg537 from './mode-537.svg';
import svg540 from './mode-540.svg';
import svg550 from './mode-550.svg';
import svg551 from './mode-551.svg';
import svg560 from './mode-560.svg';
import svg570 from './mode-570.svg';
import svg571 from './mode-571.svg';

export default {
  0: { name: 'MOVE', nameFr: 'DÉPLACER', link: '', image: svg0 },
  1: {
    name: 'POINT',
    nameFr: 'POINT',
    link: 'https://wiki.geogebra.org/en/Point_Tool',
    image: svg1,
  },
  2: {
    name: 'LINE',
    nameFr: 'LIGNE',
    link: 'https://wiki.geogebra.org/en/Line_Tool',
    image: svg2,
  },
  3: {
    name: 'PARALLEL',
    nameFr: 'PARRALÈLE',
    link: 'https://wiki.geogebra.org/en/Parallel_Line_Tool',
    image: svg3,
  },
  4: {
    name: 'ORTHOGONAL',
    nameFr: 'PERPENDICULAIRE',
    link: 'https://wiki.geogebra.org/en/Perpendicular_Line_Tool',
    image: svg4,
  },
  5: {
    name: 'INTERSECT',
    nameFr: 'INTERSECTION',
    link: 'https://wiki.geogebra.org/en/Intersect_Tool',
    image: svg5,
  },
  6: {
    name: 'DELETE',
    nameFr: 'EFFACER',
    link: 'https://wiki.geogebra.org/en/Delete_Tool',
    image: svg6,
  },
  7: {
    name: 'VECTOR',
    nameFr: 'VECTEUR',
    link: 'https://wiki.geogebra.org/en/Vector_Tool',
    image: svg7,
  },
  8: {
    name: 'LINE_BISECTOR',
    nameFr: 'MÉDIATRICE',
    link: 'https://wiki.geogebra.org/en/Perpendicular_Bisector_Tool',
    image: svg8,
  },
  9: {
    name: 'ANGULAR_BISECTOR',
    nameFr: 'BISSECTRICE',
    link: 'https://wiki.geogebra.org/en/Angle_Bisector_Tool',
    image: svg9,
  },
  10: {
    name: 'CIRCLE_TWO_POINTS',
    nameFr: 'CERCLE - CENTRE-POINT',
    link: 'https://wiki.geogebra.org/en/Circle_with_Center_through_Point_Tool',
    image: svg10,
  },
  11: {
    name: 'CIRCLE_THREE_POINTS',
    nameFr: 'CERCLE PASSANT PAR TROIS POINTS',
    link: 'https://wiki.geogebra.org/en/Circle_through_3_Points_Tool',
    image: svg11,
  },
  12: {
    name: 'CONIC_FIVE_POINTS',
    nameFr: 'CONIQUE PASSANT PAR CINQ POINTS',
    link: 'https://wiki.geogebra.org/en/Conic_through_5_Points_Tool',
    image: svg12,
  },
  13: {
    name: 'TANGENTS',
    nameFr: 'TANGENTES',
    link: 'https://wiki.geogebra.org/en/Tangents_Tool',
    image: svg13,
  },
  14: {
    name: 'RELATION',
    nameFr: 'RELATION',
    link: 'https://wiki.geogebra.org/en/Relation_Tool',
    image: svg14,
  },
  15: {
    name: 'SEGMENT',
    nameFr: 'SEGMENT',
    link: 'https://wiki.geogebra.org/en/Segment_Tool',
    image: svg15,
  },
  16: {
    name: 'POLYGON',
    nameFr: 'POLYGONE',
    link: 'https://wiki.geogebra.org/en/Polygon_Tool',
    image: svg16,
  },
  17: {
    name: 'TEXT',
    nameFr: 'TEXTE',
    link: 'https://wiki.geogebra.org/en/Text_Tool',
    image: svg17,
  },
  18: {
    name: 'RAY',
    nameFr: 'DEMI-DROITE',
    link: 'https://wiki.geogebra.org/en/Ray_Tool',
    image: svg18,
  },
  19: {
    name: 'MIDPOINT',
    link: 'https://wiki.geogebra.org/en/Midpoint_or_Center_Tool',
    nameFr: 'MILLIEU OU CENTRE',
    image: svg19,
  },
  20: {
    name: 'CIRCLE_ARC_THREE_POINTS',
    nameFr: 'ARC DE CERCLE - CENTRE-2-POINTS',
    link: 'https://wiki.geogebra.org/en/Circular_Arc_Tool',
    image: svg20,
  },
  21: {
    name: 'CIRCLE_SECTOR_THREE_POINTS',
    nameFr: 'SECTEUR CIRCULAIRE - CENTRE-2-POITS',
    link: 'https://wiki.geogebra.org/en/Circular_Sector_Tool',
    image: svg21,
  },
  22: {
    name: 'CIRCUMCIRCLE_ARC_THREE_POINTS',
    nameFr: 'ARC DE CERCLE CR�E PAR 3 POINTS',
    link: 'https://wiki.geogebra.org/en/Circumcircular_Arc_Tool',
    image: svg22,
  },
  23: {
    name: 'CIRCUMCIRCLE_SECTOR_THREE_POINTS',
    nameFr: 'SECTEUR CIRCULAIRE - CENTRE-3-POITS',
    link: 'https://wiki.geogebra.org/en/Circumcircular_Sector_Tool',
    image: svg23,
  },
  24: {
    name: 'SEMICIRCLE',
    nameFr: 'DEMI-CERCLE',
    link: 'https://wiki.geogebra.org/en/Semicircle_through_2_Points_Tool',
    image: svg24,
  },
  25: {
    name: 'SLIDER',
    nameFr: 'CURSEUR',
    link: 'https://wiki.geogebra.org/en/Slider_Tool',
    image: svg25,
  },
  26: {
    name: 'IMAGE',
    link: 'https://wiki.geogebra.org/en/Image_Tool',
    image: svg26,
  },
  27: {
    name: 'SHOW_HIDE_OBJECT',
    nameFr: "AFFICHER/CACHER L'OBJET",
    link: 'https://wiki.geogebra.org/en/Show_/_Hide_Object_Tool',
    image: svg27,
  },
  28: {
    name: 'SHOW_HIDE_LABEL',
    nameFr: "AFFICHER/CACHER L'ÉTIQUETTE",
    link: 'https://wiki.geogebra.org/en/Show_/_Hide_Label_Tool',
    image: svg28,
  },
  29: {
    name: 'MIRROR_AT_POINT',
    nameFr: 'SYMÉTRIE CENTRALE',
    link: 'https://wiki.geogebra.org/en/Reflect_about_Point_Tool',
    image: svg29,
  },
  30: {
    name: 'MIRROR_AT_LINE',
    nameFr: 'SYMÉTRIE AXIALE',
    link: 'https://wiki.geogebra.org/en/Reflect_about_Line_Tool',
    image: svg30,
  },
  31: {
    name: 'TRANSLATE_BY_VECTOR',
    nameFr: 'TRANSLATION',
    link: 'https://wiki.geogebra.org/en/Translate_by_Vector_Tool',
    image: svg31,
  },
  32: {
    name: 'ROTATE_BY_ANGLE',
    nameFr: 'ROTATION',
    link: 'https://wiki.geogebra.org/en/Rotate_around_Point_Tool',
    image: svg32,
  },
  33: {
    name: 'DILATE_FROM_POINT',
    nameFr: 'HOMOTHÉTIE',
    link: 'https://wiki.geogebra.org/en/Dilate_from_Point_Tool',
    image: svg33,
  },
  34: {
    name: 'CIRCLE_POINT_RADIUS',
    nameFr: 'CERCLE - CENTRE-RADIUS',
    link: 'https://wiki.geogebra.org/en/Circle_with_Center_and_Radius_Tool',
    image: svg34,
  },
  35: {
    name: 'COPY_VISUAL_STYLE',
    link: 'https://wiki.geogebra.org/en/Copy_Visual_Style_Tool',
    image: svg35,
  },
  36: {
    name: 'ANGLE',
    nameFr: 'ANGLE',
    link: 'https://wiki.geogebra.org/en/Angle_Tool',
    image: svg36,
  },
  37: {
    name: 'VECTOR_FROM_POINT',
    nameFr: 'REPRÉSENTANT',
    link: 'https://wiki.geogebra.org/en/Vector_from_Point_Tool',
    image: svg37,
  },
  38: {
    name: 'DISTANCE',
    nameFr: 'DISTANCE',
    link: 'https://wiki.geogebra.org/en/Distance_or_Length_Tool',
    image: svg38,
  },
  39: {
    name: 'MOVE_ROTATE',
    nameFR: 'TOURNER',
    link: 'https://wiki.geogebra.org/en/Move_around_Point_Tool',
    image: svg39,
  },
  40: {
    name: 'TRANSLATEVIEW',
    link: 'https://wiki.geogebra.org/en/Move_Graphics_View_Tool',
    image: svg40,
  },
  41: {
    name: 'ZOOM_IN',
    nameFr: 'AGRANDISSEMENT',
    link: 'https://wiki.geogebra.org/en/Zoom_In_Tool',
    image: svg41,
  },
  42: {
    name: 'ZOOM_OUT',
    nameFr: 'RÉDUCTION',
    link: 'https://wiki.geogebra.org/en/Zoom_Out_Tool',
    image: svg42,
  },
  43: { name: 'SELECTION_LISTENER', link: null, image: null },
  44: {
    name: 'POLAR_DIAMETER',
    nameFr: 'POLAIRE OU DIAMÉTRE',
    link: 'https://wiki.geogebra.org/en/Polar_or_Diameter_Line_Tool',
    image: svg44,
  },
  45: {
    name: 'SEGMENT_FIXED',
    nameFr: 'SEGMENT DE LONGUEUR DONNÉE',
    link: 'https://wiki.geogebra.org/en/Segment_with_Given_Length_Tool',
    image: svg45,
  },
  46: {
    name: 'ANGLE_FIXED',
    nameFr: 'ANGLE DE MESURE DONNÉE',
    link: 'https://wiki.geogebra.org/en/Angle_with_Given_Size_Tool',
    image: svg46,
  },
  47: {
    name: 'LOCUS',
    nameFr: 'LIEU',
    link: 'https://wiki.geogebra.org/en/Locus_Tool',
    image: svg47,
  },
  48: { name: 'MACRO', link: null, image: svg48 },
  49: {
    name: 'AREA',
    nameFr: 'AIRE',
    link: 'https://wiki.geogebra.org/en/Area_Tool',
    image: svg49,
  },
  50: {
    name: 'SLOPE',
    nameFr: 'PENTE',
    link: 'https://wiki.geogebra.org/en/Slope_Tool',
    image: svg50,
  },
  51: {
    name: 'REGULAR_POLYGON',
    nameFr: 'POLYGONE R�GULIER',
    link: 'https://wiki.geogebra.org/en/Regular_Polygon_Tool',
    image: svg51,
  },
  52: {
    name: 'SHOW_HIDE_CHECKBOX',
    nameFr: 'BOîTE DE SÉLECTION',
    link: 'https://wiki.geogebra.org/en/Check_Box_Tool',
    image: svg52,
  },
  53: {
    name: 'COMPASSES',
    nameFr: 'COMPAS',
    link: 'https://wiki.geogebra.org/en/Compass_Tool',
    image: svg53,
  },
  54: {
    name: 'MIRROR_AT_CIRCLE',
    nameFr: 'INVERSION',
    link: 'https://wiki.geogebra.org/en/Reflect_about_Circle_Tool',
    image: svg54,
  },
  55: {
    name: 'ELLIPSE_THREE_POINTS',
    nameFr: 'ELIPSE',
    link: 'https://wiki.geogebra.org/en/Ellipse_Tool',
    image: svg55,
  },
  56: {
    name: 'HYPERBOLA_THREE_POINTS',
    nameFr: 'HYPERBOLE',
    link: 'https://wiki.geogebra.org/en/Hyperbola_Tool',
    image: svg56,
  },
  57: {
    name: 'PARABOLA',
    nameFr: 'PARABOLE',
    link: 'https://wiki.geogebra.org/en/Parabola_Tool',
    image: svg57,
  },
  58: {
    name: 'FITLINE',
    nameFr: "DROITE D'AJUSTEMENT",
    link: 'https://wiki.geogebra.org/en/Best_Fit_Line_Tool',
    image: svg58,
  },
  59: { name: 'RECORD_TO_SPREADSHEET', link: null, image: svg59 },
  60: {
    name: 'BUTTON_ACTION',
    nameFr: 'BOUTON',
    link: 'https://wiki.geogebra.org/en/Button_Tool',
    image: svg60,
  },
  61: {
    name: 'TEXTFIELD_ACTION',
    nameFr: 'CHAMP TEXTE',
    link: 'https://wiki.geogebra.org/en/Input_Box_Tool',
    image: svg61,
  },
  62: {
    name: 'PEN',
    nameFr: 'STYLO',
    link: 'https://wiki.geogebra.org/en/Pen_Tool',
    image: svg62,
  },
  64: {
    name: 'Rigid Polygon',
    nameFr: 'POLYGONE IND�FORMABLE',
    link: 'https://wiki.geogebra.org/en/Rigid_Polygon_Tool',
    image: svg64,
  },
  65: {
    name: 'Polyline',
    nameFr: 'LIGNE BRISÉE',
    link: 'https://wiki.geogebra.org/en/Polyline_Tool',
    image: svg65,
  },
  66: {
    name: 'Probability',
    nameFR: 'ProbabilitÉ',
    link: 'https://wiki.geogebra.org/en/Probability_Calculator',
    image: svg66,
  },
  67: {
    name: 'Attach / Detach',
    nameFr: 'Lier/LibÉrer point',
    link: 'https://wiki.geogebra.org/en/Attach_/_Detach_Point_Tool',
    image: svg67,
  },
  68: {
    name: 'Function Inspector',
    nameFr: 'INSPECTEUR DE FONCTION',
    link: 'https://wiki.geogebra.org/en/Function_Inspector_Tool',
    image: svg68,
  },
  69: {
    name: 'Intersect Two Surfaces',
    link: 'https://wiki.geogebra.org/en/Intersect_Two_Surfaces_Tool',
    image: null, // error on the ggb site...theyve linked to it improperly
  },
  70: {
    name: 'Vector Polygon',
    nameFr: 'POLYGONE SEMI-DÉFORMALE',
    link: 'https://wiki.geogebra.org/en/Vector_Polygon_Too',
    image: svg70,
  },
  71: {
    name: 'Create List',
    nameFr: 'LISTE',
    link: 'https://wiki.geogebra.org/en/List_Tool',
    image: svg71,
  },
  72: {
    name: 'Complex Number',
    nameFr: 'Nombre complexe',
    link: 'https://wiki.geogebra.org/en/Complex_Number_Tool',
    image: svg72,
  },
  501: {
    name: 'Point on object',
    nameFr: 'Point sur Objet',
    link: 'https://wiki.geogebra.org/en/Point_on_Object_Tool',
    image: svg501,
  },
  2001: {
    name: 'MODE_SPREADSHEET_CREATE_LIST',
    link: 'https://wiki.geogebra.org/en/List_Tool',
    image: svg71,
  },
  2002: {
    name: 'MODE_SPREADSHEET_CREATE_MATRIX',
    link: 'https://wiki.geogebra.org/en/Matrix_Tool',
    image: svg2002,
  },
  2003: {
    name: 'SPREADSHEET_CREATE_LISTOFPOINTS',
    link: 'https://wiki.geogebra.org/en/List_of_Points_Tool',
    image: svg2003,
  },
  2004: {
    name: 'SPREADSHEET_CREATE_TABLETEXT',
    link: 'https://wiki.geogebra.org/en/Table_Tool',
    image: svg2004,
  },
  2005: {
    name: 'SPREADSHEET_CREATE_POLYLINE',
    link: 'https://wiki.geogebra.org/en/Polyline_Tool',
    image: svg2005,
  },
  2020: {
    name: 'SPREADSHEET_ONEVARSTATS',
    link: 'https://wiki.geogebra.org/en/One_Variable_Analysis_Tool',
    image: svg2020,
  },
  2021: {
    name: 'SPREADSHEET_TWOVARSTATS',
    link: 'https://wiki.geogebra.org/en/Two_Variable_Regression_Analysis_Tool',
    image: svg2021,
  },
  2022: {
    name: 'SPREADSHEET_MULTIVARSTATS',
    link: 'https://wiki.geogebra.org/en/Multiple_Variable_Analysis_Tool',
    image: svg2022,
  },
  2030: { name: 'SPREADSHEET_SORT', link: null, image: null },
  2031: { name: 'SPREADSHEET_SORT_AZ', link: null, image: null },
  2032: { name: 'SPREADSHEET_SORT_ZA', link: null, image: null },
  2040: {
    name: 'SPREADSHEET_SUM',
    link: 'https://wiki.geogebra.org/en/Sum_Tool',
    image: svg2040,
  },
  2041: {
    name: 'SPREADSHEET_AVERAGE',
    link: 'https://wiki.geogebra.org/en/Mean_Tool',
    image: svg2041,
  },
  2042: {
    name: 'SPREADSHEET_COUNT',
    link: 'https://wiki.geogebra.org/en/Count_Tool',
    image: svg2042,
  },
  2043: {
    name: 'SPREADSHEET_MIN',
    link: 'https://wiki.geogebra.org/en/Minimum_Tool',
    image: svg2043,
  },
  2044: {
    name: 'SPREADSHEET_MAX',
    link: 'https://wiki.geogebra.org/en/Maximum_Tool',
    image: svg2044,
  },
  73: {
    name: 'Freehand',
    nameFr: 'CROQUIS',
    link: 'https://wiki.geogebra.org/en/Freehand_Shape_Tool',
    image: svg73,
  },
  502: {
    name: 'VIEW_IN_FRONT_OF',
    link: 'https://wiki.geogebra.org/en/View_in_front_of_Tool',
    image: svg502,
  },
  510: {
    name: 'PLANE_THREE_POINTS',
    link: 'https://wiki.geogebra.org/en/Plane_through_3_Points_Tool',
    image: svg510,
  },
  511: {
    name: 'PLANE_POINT_LINE',
    link: 'https://wiki.geogebra.org/en/Plane_Tool',
    image: svg511,
  },
  512: {
    name: 'ORTHOGONAL_PLANE',
    link: 'https://wiki.geogebra.org/en/Perpendicular_Plane_Tool',
    image: svg512,
  },
  513: {
    name: 'PARALLEL_PLANE',
    link: 'https://wiki.geogebra.org/en/Parallel_Plane_Tool',
    image: svg513,
  },
  514: {
    name: 'Perpendicular line (3D)',
    link: 'https://wiki.geogebra.org/en/Perpendicular_Line_Tool',
    image: svg514,
  },
  520: {
    name: 'SPHERE_POINT_RADIUS',
    link: 'https://wiki.geogebra.org/en/Sphere_with_Center_and_Radius_Tool',
    image: svg520,
  },
  521: {
    name: 'SPHERE_TWO_POINTS',
    link: 'https://wiki.geogebra.org/en/Sphere_with_Center_through_Point_Tool',
    image: svg521,
  },
  522: {
    name: 'Cone',
    link: 'https://wiki.geogebra.org/en/Cone_Tool',
    image: svg522,
  },
  523: {
    name: 'Cylinder',
    link: 'https://wiki.geogebra.org/en/Cylinder_Tool',
    image: svg523,
  },
  531: {
    name: 'Prism',
    link: 'https://wiki.geogebra.org/en/Prism_Tool',
    image: svg531,
  },
  532: {
    name: 'Extrude Cylinder',
    link: 'https://wiki.geogebra.org/en/Extrude_to_Prism_or_Cylinder_Tool',
    image: svg532,
  },
  533: {
    name: 'Pyramid',
    link: 'https://wiki.geogebra.org/en/Pyramid_Tool',
    image: svg533,
  },
  534: {
    name: 'Extrude Cone',
    link: 'https://wiki.geogebra.org/en/Extrude_to_Pyramid_or_Cone_Tool',
    image: svg534,
  },
  535: {
    name: 'Net',
    link: 'https://wiki.geogebra.org/en/Net_Tool',
    image: svg535,
  },
  536: {
    name: 'Cube',
    link: 'https://wiki.geogebra.org/en/Cube_Tool',
    image: svg536,
  },
  537: {
    name: 'Tetrahedron',
    link: 'https://wiki.geogebra.org/en/Regular_Tetrahedron_Tool',
    image: svg537,
  },
  540: {
    name: 'Rotate View',
    link: 'https://wiki.geogebra.org/en/Rotate_3D_Graphics_View_Tool',
    image: svg540,
  },
  550: {
    name: 'Circle Point Radius Direction',
    link:
      'https://wiki.geogebra.org/en/Circle_with_Center,_Radius_and_Direction_Tool',
    image: svg550,
  },
  551: {
    name: 'Circle Axis Point',
    link: 'https://wiki.geogebra.org/en/Circle_with_Axis_through_Point_Tool',
    image: svg551,
  },
  560: {
    name: 'Volume',
    link: 'https://wiki.geogebra.org/en/Volume_Tool',
    image: svg560,
  },
  570: {
    name: 'Rotate around Line',
    link: 'https://wiki.geogebra.org/en/Rotate_around_Line_Tool',
    image: svg570,
  },
  571: {
    name: 'Mirror at Plane',
    link: 'https://wiki.geogebra.org/en/Reflect_about_Plane_Tool',
    image: svg571,
  },
};



// WEBPACK FOOTER //
// ./src/Containers/Workspace/Tools/GgbIcons/index.js